export default `
<div>
  <div class="block container">
    <div class="row">
      <div class="col-sm-12">
        <div class="search-result">
          <h2>Search Results for &ldquo;{{$ctrl.searchByTag || $ctrl.query}}&rdquo;</h2>
          <div class="pull-right">
            <ut-custom-dropdown ng-if="$ctrl.sortable()" [options]="$ctrl.sortingOptions" [model]="$ctrl.sorting" (on-change)="$ctrl.sortingChanged($event)"></ut-custom-dropdown>
          </div>
          <div class="search-result-section">
            <uib-tabset>
              <uib-tab ng-repeat="type in $ctrl.types" heading="{{type}}" active="$ctrl.tabStates[type]" select="$ctrl.selectTab(type)">
                <feed-item item="item" ng-repeat="item in $ctrl.resultsFeed.feedItems | filter: {type: '!course'}"></feed-item>
                <p class="feed-loading-message" ng-if="!$ctrl.resultsFeed.isLoading && ($ctrl.resultsFeed.feedItems | filter: {type: '!course'}).length == 0" >No Results</p>
                <ut-load-more (load-more)="$ctrl.resultsFeed.loadMore()" [is-loading]="$ctrl.resultsFeed.isLoading" [is-last-page]="$ctrl.resultsFeed.isLastPage"></ut-load-more>
              </uib-tab>
            </uib-tabset>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
